import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import NavbarComp from '../components/NavbarComp'
import FooterComp from '../components/FooterComp'

const MainLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
        <NavbarComp />
        <Outlet />
        <FooterComp />
    </>
  )
}

export default MainLayout